/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LowerSection/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentCount from './AppointmentCount/index'
import ChairCount from './ChairCount/index'
import DownloadAction from './DownloadAction/index'
import FilterAction from './FilterAction/index'
import HipaaAction from './HipaaAction/index'
import PatientCount from './PatientCount/index'
import React from 'react'
import SettingsAction from './SettingsAction/index'
import SlotIntervalAction from './SlotIntervalAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LowerSection({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="LowerSection.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z2i1j': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-Z2i1j': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-Z2i1j': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-Z2i1j': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bbc-5-Z2i1j': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="LowerSection.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-6-Z2i1j': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<SlotIntervalAction
  viewPath={`${viewPath}/SlotIntervalAction`}
/>
<div
  data-testid="LowerSection.Vertical"
  data-view-path={viewPath}
 style={{'--bc-7-Z2i1j': dtColorsNeutral200,'--mr-8-Z2i1j': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--ml-9-Z2i1j': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
/>
<FilterAction
  viewPath={`${viewPath}/FilterAction`}
/>
<ChairCount
  viewPath={`${viewPath}/ChairCount`}
/>
<HipaaAction
  viewPath={`${viewPath}/HipaaAction`}
/>
<SettingsAction
  viewPath={`${viewPath}/SettingsAction`}
/>
<DownloadAction
  viewPath={`${viewPath}/DownloadAction`}
/>
<div
  data-testid="LowerSection.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-6-Z2i1j': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<AppointmentCount
  viewPath={`${viewPath}/AppointmentCount`}
/>
<div
  data-testid="LowerSection.Horizontal:3"
  data-view-path={viewPath}
 style={{'--w-10-Z2i1j': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--h-11-Z2i1j': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-12-Z2i1j': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal3}`}
/>
<PatientCount
  viewPath={`${viewPath}/PatientCount`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}